import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from "@mui/material";
import theme from './theme';
import { AuthProvider } from "./hooks/AuthContext"; // ajustá la ruta si hace falta



// Elimina el preloader una vez que React está listo
const preloader = document.getElementById("preloader");
if (preloader) {
  preloader.remove();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
